import DevourClient from 'devour-client';

export const TYPE = 'story';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			title: '',
			content: '',
			relevantFrom: '',
			relevantUntil: '',
			dateFilled: '',
			postedAt: '',
			unlocksAt: '',
			pinnedAt: '',
			approved: '',
			published: '',
			location: '',
			geolocation: '',
			longitude: '',
			latitude: '',
			orientation: '',
			favoritesCount: '',
			commentsCount: '',
			type: '',
			createdAt: '',
			updatedAt: '',
			attachment: {},
			image: {},
			imageMeta: {},
			initials: '',
			slug: '',
			username: '',
			user: {
				jsonApi: 'hasOne',
				type: 'user',
			},
			comments: {
				jsonApi: 'hasMany',
				type: 'comment',
			},
			favorites: {
				jsonApi: 'hasMany',
				type: 'user/favorite',
			},
			favoriter: {
				jsonApi: 'hasOne',
				type: 'user/favorite',
			},
		},
		{
			type: 'user/story',
		}
	);

	return client;
}
